import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsRowCss = ":host {\n  --row-gap-y: 10px;\n  --row-gap-x: 10px;\n  display: block;\n  -webkit-margin-after: calc(var(--row-gap-y) * -1);\n  margin-block-end: calc(var(--row-gap-y) * -1);\n  -webkit-margin-before: calc(var(--row-gap-y) * -1);\n  margin-block-start: calc(var(--row-gap-y) * -1);\n  -webkit-margin-end: calc(var(--row-gap-x) * -0.5);\n  margin-inline-end: calc(var(--row-gap-x) * -0.5);\n  -webkit-margin-start: calc(var(--row-gap-x) * -0.5);\n  margin-inline-start: calc(var(--row-gap-x) * -0.5);\n}\n\n.pds-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-margin-after: calc(var(--row-gap-y) * -1);\n  margin-block-end: calc(var(--row-gap-y) * -1);\n  -webkit-margin-before: calc(var(--row-gap-y) * -1);\n  margin-block-start: calc(var(--row-gap-y) * -1);\n  -webkit-margin-end: calc(var(--row-gap-x) * -1);\n  margin-inline-end: calc(var(--row-gap-x) * -1);\n  -webkit-margin-start: calc(var(--row-gap-x) * -1);\n  margin-inline-start: calc(var(--row-gap-x) * -1);\n}\n@layer layout {\n  .pds-row > * {\n    -webkit-padding-after: calc(var(--row-gap-y));\n    padding-block-end: calc(var(--row-gap-y));\n    -webkit-padding-before: calc(var(--row-gap-y));\n    padding-block-start: calc(var(--row-gap-y));\n    -webkit-padding-end: calc(var(--row-gap-x));\n    padding-inline-end: calc(var(--row-gap-x));\n    -webkit-padding-start: calc(var(--row-gap-x));\n    padding-inline-start: calc(var(--row-gap-x));\n  }\n}\n\n.pds-row--no-wrap {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n\n.pds-row--border {\n  border: var(--pine-border);\n}\n\n.pds-justify-content-start {\n  -ms-flex-pack: start;\n  justify-content: start;\n}\n\n.pds-justify-content-center {\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.pds-justify-content-end {\n  -ms-flex-pack: end;\n  justify-content: end;\n}\n\n.pds-justify-content-space-between {\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.pds-justify-content-space-around {\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n\n.pds-justify-content-space-evenly {\n  -ms-flex-pack: space-evenly;\n  justify-content: space-evenly;\n}\n\n.pds-align-items-start {\n  -ms-flex-align: start;\n  align-items: start;\n}\n\n.pds-align-items-center {\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.pds-align-items-end {\n  -ms-flex-align: end;\n  align-items: end;\n}\n\n.pds-align-items-stretch {\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.pds-align-items-baseline {\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}";
const PdsRowStyle0 = pdsRowCss;

const PdsRow$1 = /*@__PURE__*/ proxyCustomElement(class PdsRow extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.colGapMap = {
            none: '0',
            xxs: '.25rem',
            xs: '.5rem',
            sm: '1rem',
            md: '1.5rem',
            lg: '2.25rem',
            xl: '3rem',
            xxl: '4rem',
        };
        this.alignItems = undefined;
        this.border = false;
        this.colGap = undefined;
        this.componentId = undefined;
        this.justifyContent = undefined;
        this.minHeight = undefined;
        this.noWrap = false;
    }
    render() {
        const rowClasses = `
    ${this.alignItems !== undefined && this.alignItems.trim() !== '' ? `pds-align-items-${this.alignItems}` : ''}
    ${this.border ? 'pds-row--border' : ''}
    ${this.justifyContent !== undefined && this.justifyContent.trim() !== '' ? `pds-justify-content-${this.justifyContent}` : ''}
    ${this.noWrap ? 'pds-row--no-wrap' : ''}
  `;
        const rowInlineStyles = Object.assign(Object.assign({}, (this.colGap && {
            '--row-gap-x': this.colGap !== undefined && this.colGap.trim() !== '' ? this.colGapMap[this.colGap] : '',
            '--row-gap-y': this.colGap !== undefined && this.colGap.trim() !== '' ? this.colGapMap[this.colGap] : '',
        })), (this.minHeight && {
            'min-height': this.minHeight,
        }));
        return h(Host, { key: '1760d9bd45d53d371c0a4c73171a12a6e4c59b51', class: `pds-row ${rowClasses}`, style: rowInlineStyles });
    }
    static get style() { return PdsRowStyle0; }
}, [0, "pds-row", {
        "alignItems": [1, "align-items"],
        "border": [4],
        "colGap": [1, "col-gap"],
        "componentId": [1, "component-id"],
        "justifyContent": [1, "justify-content"],
        "minHeight": [1, "min-height"],
        "noWrap": [4, "no-wrap"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-row"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-row":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsRow$1);
            }
            break;
    } });
}

const PdsRow = PdsRow$1;
const defineCustomElement = defineCustomElement$1;

export { PdsRow, defineCustomElement };

//# sourceMappingURL=pds-row.js.map